var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex text-base justify-between pb-2 font-semibold mb-6",class:_vm.border},[(_vm.$slots.default)?[_vm._t("default")]:[_c('div',[_vm._t("left")],2),_c('div',{staticClass:"text-primary-500"},[_vm._t("right")],2)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }